import { apiGet, apiPost, apiPatch, apiDelete } from './client';
import type { Company } from '../types';

export async function getCompanies(): Promise<Company[]> {
  return apiGet<Company[]>('/companies');
}

export async function getCompany(id: string): Promise<Company> {
  return apiGet<Company>(`/companies/${id}`);
}

export async function createCompany(data: { name: string; document: string; status?: string }): Promise<Company> {
  return apiPost<Company>('/companies', data);
}

export async function updateCompany(id: string, data: Partial<Company>): Promise<Company> {
  return apiPatch<Company>(`/companies/${id}`, data);
}

export async function deleteCompany(id: string): Promise<void> {
  return apiDelete<void>(`/companies/${id}`);
}

export async function getCompanyMemoryStats(id: string): Promise<{ count: number }> {
  return apiGet<{ count: number }>(`/companies/${id}/memories/stats`);
}

export async function clearCompanyMemories(id: string): Promise<void> {
  return apiDelete<void>(`/companies/${id}/memories`);
}
